import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

export const ProductPageOdsDialogMainInfoSection: FC = () => {
  return (
    <div className="mt-2.5 text-dark-primary-max">
      <FormattedMessage id="pdp.buyboxwithvariants.odsModal.main.info.desc" />
    </div>
  )
}
